<span class="required" tooltip="{{'REQUIRED_FIELD' | translate}}" placement="right">*</span>
